import { render, staticRenderFns } from "./loginChoose.vue?vue&type=template&id=f6c1a2d2&scoped=true&"
import script from "./loginChoose.vue?vue&type=script&lang=js&"
export * from "./loginChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c1a2d2",
  null
  
)

export default component.exports